export default __webpack_public_path__ + "static/media/repayment-channel-icon8.ca4ad1d2.png";